import { EMPTY_OBJECT } from '../../constants/common'
import { useInfiniteItemsListLoader } from '../../hooks'
import { List as ListComponent } from '../List'
import { EmptyListItem, LoaderListItem } from '../ListItem'

import { ASYNC_LIST_LOADER_PROPS_DEFAULT } from './AsyncList.constants'
import { getLoadingRules } from './AsyncList.utils'

function AsyncList({
  List = ListComponent,
  ListItem = 'div',
  Loader = LoaderListItem,
  NoDataList = null,
  NoDataListItem = EmptyListItem,
  apiParams,
  checkIsLastPage,
  filters,
  getApiParamsInit,
  getApiParamsLoadNext,
  getApiParamsUpdate,
  getData,
  getDataItems,
  getShowEmptyListRules = getLoadingRules,
  getTotalCountData,
  listItemProps = EMPTY_OBJECT,
  loaderProps = ASYNC_LIST_LOADER_PROPS_DEFAULT,
  preloading,
  thresholdEndIndex,
  withPagination = true,
  onChangeInitialized,
  onChangePermissions,
  onChangeTotalCount,
  onFilterItems,
  ...restProps
}) {
  const {
    getThresholdItemProps,
    items,
    loadingInitial,
    loadingMore,
    updateListData,
  } = useInfiniteItemsListLoader({
    apiParams,
    checkIsLastPage,
    filters,
    getApiParamsInit,
    getApiParamsLoadNext,
    getApiParamsUpdate,
    getData,
    getDataItems,
    getTotalCountData,
    preloading,
    thresholdEndIndex,
    withPagination,
    onChangeInitialized,
    onChangePermissions,
    onChangeTotalCount,
    onFilterItems,
  })

  const showEmptyList = getShowEmptyListRules(items, loadingInitial)

  if (NoDataList && showEmptyList) {
    return <NoDataList />
  }

  return (
    <List {...restProps}>
      {!loadingInitial && items?.length === 0 ? <NoDataListItem /> : null}
      {items?.map((item, index) => (
        <ListItem
          {...listItemProps}
          {...getThresholdItemProps(index)}
          key={index}
          updateListData={updateListData}
          value={item}
        />
      ))}
      {loadingInitial || loadingMore ? <Loader {...loaderProps} /> : null}
    </List>
  )
}

export default AsyncList
